import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Autocomplete, TextField, ListItemText, Stack, Chip, ListItem } from '@mui/material';
import BaseFieldEditor from './BaseFieldEditor';

const UnitTypeEditor = ({
  open,
  loading,
  units,
  unitsById,
  measurements,
  pointTypes,
  column,
  editing,
  currentlyEditing,
  setCurrentlyEditing,
  setCurrentEditor,
  actions,
}) => {
  if (!editing || editing.length <= 0) return null;
  const [selectedOption, setSelectedOption] = useState(unitsById[editing[0].raw_unit_id]);

  const isValidUnit = (unitId) => {
    if (editing.length !== 1) return false;
    const pointType = pointTypes[editing[0].point_type_id];
    const measurement = measurements[pointType?.measurementId];

    return measurement?.units.some((u) => u.id === unitId);
  };

  return (
    <BaseFieldEditor
      loading={loading}
      open={open}
      onSave={() => {
        const action = actions.find((a) => a.id === column.action);
        action.doSave(editing, {
          'p.tagged_units': selectedOption.name_abbr,
          'p.tagged_units.cnf': 100,
        });
        action.doClose({ currentlyEditing, setCurrentlyEditing, column, setCurrentEditor });
      }}
      title="Unit Type Editor"
      editing={editing}
      column={column}
      currentlyEditing={currentlyEditing}
      setCurrentlyEditing={setCurrentlyEditing}
      setCurrentEditor={setCurrentEditor}
      actions={actions}
    >
      <Autocomplete
        options={units}
        onChange={(_event, newValue) => {
          setSelectedOption(newValue);
        }}
        getOptionLabel={(unit) => unit.name_long}
        value={selectedOption}
        renderOption={(props, option) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <ListItem {...props}>
            <ListItemText>{option.name_long}</ListItemText>
            <Stack direction="row" spacing={4}>
              {isValidUnit(option.id) ? <Chip label="Valid" /> : null}
            </Stack>
          </ListItem>
        )}
        // eslint-disable-next-line react/jsx-props-no-spreading
        renderInput={(params) => <TextField label="Select Unit Type" {...params} />}
      />
    </BaseFieldEditor>
  );
};

export default connect(
  ({
    entities: {
      units: { all, byId },
      measurements: { byId: measurementsById },
      pointTypes: { byId: pointTypesById },
    },
  }) => ({
    units: all,
    unitsById: byId,
    measurements: measurementsById,
    pointTypes: pointTypesById,
  })
)(UnitTypeEditor);
